import { inject } from '@angular/core';
import { CanActivateFn, CanActivateChildFn, Router } from '@angular/router';
import { SessaoStore } from '../store/sessao.store';

const verificarSessao = () => {
  const store = inject(SessaoStore);
  if (store.verificarValidade()) return true;
  store.limpar();
  return inject(Router).createUrlTree(['/login']);
};

export const sessaoGuard: CanActivateFn = verificarSessao;
export const sessaoChildGuard: CanActivateChildFn = verificarSessao;
